<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                <strong>Required Action: </strong>Swittch to a Toll-free Phone Number
            </h2>
        </template>

        <div>
            <div class="max-w-7xl m-4 py-10 sm:px-6 lg:px-8 shadow sm:rounded-md bg-white">
                <div class='font-bold' >What do I need to do?</div>
                <div>
                    <Link href="/select-number" class="text-blue-400 font-semibold">Select a new toll-free phone number </Link>for your TextSpot account. This switch is free and is required. If you don’t select a new toll-free number, one will be assigned to you before July 5th, 2023.
                </div>

                <div class="font-bold mt-4">Why is this happening?</div>
                <div>
                    Telecommunication carriers (Verizon, ATT, etc.) are requiring local phone numbers that send messages from applications like TextSpot to be verified so they know who is sending messages across their networks.
                </div>
                <div class="mt-4">
                    The verification process for local phone numbers is different than the toll-free phone number verification process. To ensure your messages are successfully delivered to your contacts, TextSpot is choosing to switch to toll-free numbers.
                </div>
                

                <div class="font-bold mt-4">What does this mean for my account?</div>
                <div>You will have a new number to send and receive messages from TextSpot. No other changes will be made to your account.</div>

                <div>Once you switch to a toll-free phone number you will no longer receive incoming messages to your previous phone number.</div>

                <div class="font-bold mt-4">Can I get my current local number verified and keep it?</div>
                <div>Yes. However, that is not our recommendation as the verification process (managed by a third-party company, not TextSpot) is currently unreliable and very slow. You would potentially go several weeks without being able to use your local phone number until you are verified. If you would like to try visit our 
                    <Link href="/verified/start" class="text-blue-400 font-semibold">Verified Sender application page</Link>.</div>

                <div class="italic mt-4">Thank you for your patience as we manage the constantly evolving A2P (application-to-person) messaging industry changes.</div>

                <div class='italic mt-4'>If you have any additional questions, please start a chat with our support team.</div>

                <Link href="/select-number">
                    <jet-button class="mt-8">
                        Select Toll-free number
                    </jet-button>
                </Link>

            </div>
        </div>
    </app-layout>
</template>

<script setup>
import AppLayout from "../../Layouts/AppLayout";
import JetButton from "./../../Jetstream/Button";
</script>
